import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import AppOverview from './AppOverview';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

const styleSheet = theme => ({
    paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflow: 'auto',
    },
    appResultContainer:{
      float: 'left',
      marginRight: 20,
      maxWidth: 420,
      minWidth: 200,
      [theme.breakpoints.up('xs')]: {
        width: 'calc(100% - 16px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 420,
      },
    }
});

class AppList extends React.Component {
    render () {
      const theprops = this.props;
      const theal = theprops.al;
      const thenodes = theal.nodes;
      const sterm = this.props.sterm;
      const classes = this.props.classes;

      return (
        <div id="applist" style={{clear:'right'}}>
          {thenodes.map(n => {
            return (
            <div key={n.appId} className={classes.appResultContainer}>
              <AppOverview app={n} sterm={sterm} auth={this.props.auth} history={this.props.history}/>
            </div>
            );
          })}
          <div style={{clear:'both'}}></div>
        </div>
      );
    }
}

AppList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(AppList), { al: graphql`
  fragment AppList_al on AppTsConnection {
    nodes {
        appId
        accountId
        appStatus
        appName
        appSku
        appUrl
        appLogo
        description
        appType
        parentAppId
        oemAppId
        atId
        appSkuPrice
        appMarkupAbsolute
        appMarkupPercentage
        jitFloatDefault
        marqetaMid
        marqetaMname
        maxCharge
        paymentOrder
        billingFrequency
        customerAppTsByAppId {
            totalCount
        }
    }
  }
`});
